import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        course: '=',
        occurrence: '=',
        canManageOccurrences: '=',
        context: '=',
        sites: '=',
        courseVersions: '=',
        directManagers: '='
    },
    template: `
        <h2>{{ 'course.General data' | translate }}</h2>
        <form class="form" ng-submit="vm.save()">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.name">
                    <label class="label">
                        {{ 'course.Occurrence name' | translate }} *
                        <tooltip html="vm.tooltipTexts.name" />
                    </label>
                    <div class="items">
                        <input ng-model="vm.form.model.name" type="text" class="form-control"
                            ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                            ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.siteIds">
                <label class="label">{{ 'course.Site' | translate }} *</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.multiFilter.sites.options"
                        selected-model="vm.multiFilter.sites.models"
                        extra-settings="vm.multiFilter.sites.settings"
                        events="vm.multiFilter.sites.events"
                        disabled="!vm.canManageOccurrences"
                        translation-texts="vm.multiFilter.sites.translations"
                    ></div>
                </div>
            </form-row>
                <form-row
                    ng-if="vm.form.model.siteAccess===vm.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES && vm.course.company.isTrainingCompany"
                    error="vm.form.errors.isExternalSiteUserExcluded"
                >
                    <label class="label">{{ 'course.Exclude employees from external sites' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isExternalSiteUserExcluded"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.courseVersionId">
                    <label class="label">{{ 'course.Version' | translate }} *</label>
                    <div class="items">
                        <select
                            ng-model="vm.form.model.courseVersionId"
                            class="form-control"
                            ng-readonly="!vm.canManageOccurrences"
                            ng-disabled="!vm.canManageOccurrences"
                            ng-options="version.id as version.name for version in vm.courseVersions"
                        />
                        </select>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.capacity">
                    <label class="label">
                        {{ 'course.Occurrence maximum capacity' | translate }}
                        <small>{{ 'course.Employees' | translate }}</small>
                    </label>
                    <div class="items">
                        <input ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                               ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                               ng-model="vm.form.model.capacity" type="number" min="1" class="form-control small">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.trainingTimeCapacity">
                    <label class="label">
                        {{ 'course.Training time maximum capacity' | translate }}
                        <small>{{ 'course.Employees' | translate }}</small>
                    </label>
                    <div class="items">
                        <input ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                               ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                               ng-model="vm.form.model.trainingTimeCapacity" type="number" min="1" class="form-control small">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.isLimitAccessEnabled">
                    <span class="label">{{ 'courses.Limit access period' | translate }}</span>
                    <div class="items">
                        <label class="switch01" style="margin-top: 23px">
                            <input type="checkbox" name="switch" ng-model="vm.form.model.isLimitAccessEnabled" ng-change="vm.handleLimitAccessEnabled()">
                            <span>Yes</span>
                        </label>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.accessPeriod || vm.form.errors.accessPeriodType" ng-if="vm.form.model.isLimitAccessEnabled">
                    <label class="label">{{ 'courses.Access period' | translate }}
                        <span class="tooltip-icon"
                              tooltip-trigger="outsideClick"
                              tooltip-append-to-body="true"
                              uib-tooltip-html="vm.getAccessLimitTooltipText()"
                        >?</span>
                    </label>
                    <div class="items">
                        <input type="number" class="form-control small02" min="1" ng-model="vm.form.model.accessPeriod">
                        <select class="form-control small02" ng-model="vm.form.model.accessPeriodType">
                            <option value="{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.HOUR }}">{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.HOUR }}</option>
                            <option value="{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.DAY }}">{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                            <option value="{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.KEYS.WEEK }}">{{ vm.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                        </select>
                    </div>
                </form-row>
                <form-row ng-if="vm.course.company.isTrainingCompany" error="vm.form.errors.isMarketplaceOccurrence">
                    <label class="label">{{ 'course.Use in training marketplace' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isMarketplaceOccurrence"
                                ng-change="vm.handleLimitAccessEnabled()"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.isMarketplaceOccurrence" error="vm.form.errors.hideFromMarketplaceList">
                    <label class="label">{{ 'course.Hide from marketplace view' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.hideFromMarketplaceList"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.isMarketplaceOccurrence" error="vm.form.errors.isMarketplaceRegistrationDisabled">
                    <label class="label">{{ 'course.Registration in marketplace not allowed' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isMarketplaceRegistrationDisabled"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.isMarketplaceOccurrence" error="vm.form.errors.marketplaceSalesPrice">
                    <label class="label">
                        {{ 'course.Sales price' | translate }}
                        <small>({{ 'price.Without VAT' | translate }})</small>
                    </label>
                    <div class="items">
                        <input class="form-control small" ng-model="vm.form.model.marketplaceSalesPrice"
                            ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                            ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                            ng-blur="vm.afterMarketplaceSalesPriceChange()"
                        >
                       <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.isMarketplaceOccurrence" error="vm.form.errors.languages">
                    <label class="label">{{ 'course.Occurrence language' | translate }} *</label>
                    <div class="items">
                        <tags-input
                            key-property="value"
                            display-property="label"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            ng-model="vm.languages"
                            ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                            ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                            placeholder="{{ 'occurrence.Add a language' | translate }}">
                            <auto-complete min-length="1" source="vm.filterLanguages($query)"></auto-complete>
                        </tags-input>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.course.company.isOptionalCoursesModuleEnabled" error="vm.form.errors.isOptionalTargetsOccurrence">
                    <label class="label">{{ 'course.Display to optional targets' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isOptionalTargetsOccurrence"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row
                    ng-if="vm.form.model.isOptionalTargetsOccurrence"
                    error="vm.form.errors.isAutomaticRegistrationAllowed"
                    additional-classes="'row-indented'"
                    >
                    <label class="label">
                        {{ 'course.Automatic registration allowed' | translate }}
                        <tooltip html="vm.tooltipTexts.automaticRegistration" />
                    </label>
                    <div class="items">
                        <label class="switch01" style="margin-top: 23px">
                            <input
                                name="switch"
                                type="checkbox"
                                ng-model="vm.form.model.isAutomaticRegistrationAllowed"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                            >
                        <span>{{ 'general.Yes' | translate }}</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row
                    ng-if="vm.form.model.isOptionalTargetsOccurrence"
                    error="vm.form.errors.displayUntil"
                    additional-classes="'row-indented'"
                    >
                    <label class="label">{{ 'course.Display until' | translate }}</label>
                    <div class="items">
                        <datetimepicker ng-model="vm.form.model.displayUntil" default-time="'23:59'" ng-disabled="!vm.PrivilegeService.canManageOccurrences()">
                        </datetimepicker>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.isUsedInExternalSystem">
                    <label class="label">
                        {{ 'course.Use in external system' | translate }}
                        <tooltip html="vm.tooltipTexts.externalUsage" />
                    </label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isUsedInExternalSystem"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors.isExposedToDirectManagers">
                    <label class="label">{{ 'course.Direct manager can add employees to occurrence' | translate }}</label>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox"
                                name="switch"
                                ng-model="vm.form.model.isExposedToDirectManagers"
                                ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                                ng-readonly="!vm.PrivilegeService.canManageOccurrences()">
                            <span>Yes</span>
                        </label>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.form.model.isExposedToDirectManagers" error="vm.form.errors.directManagerIds">
                    <label class="label">
                        {{ 'course.List of direct managers' | translate }}
                        <small>{{ 'course.List of managers who can add employees to occurrence' | translate }}</small>
                    </label>
                    <div class="items">
                        <div ng-if="!vm.PrivilegeService.canManageOccurrences()" class="multiselect-parent btn-group">
                            <button disabled="disabled" type="button" class="ng-binding btn btn-default">
                                {{ vm.getSelectedDirectManagersAsString() }}
                            </button>
                        </div>
                        <div ng-if="vm.PrivilegeService.canManageOccurrences()"
                                ng-dropdown-multiselect=""
                                options="vm.directManagerSelect.options"
                                selected-model="vm.directManagerSelect.model"
                                extra-settings="vm.directManagerSelect.settings"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.TokenService.isBudgetModuleEnabled()" error="vm.form.errors.budgetType">
                    <label class="label">
                        {{ 'course.Budget' | translate }}
                    </label>
                    <ul class="checkboxes">
                        <li>
                            <label><input type="radio" ng-model="vm.form.model.budgetType"> {{ 'course.N/A' | translate }}</label>
                            <label ng-repeat="(value, label) in vm.OCCURRENCE_BUDGET_ENUM.LABELS">
                                <input type="radio" ng-model="vm.form.model.budgetType" value="{{ value }}"> {{ label }}
                            </label>
                        </li>
                    </ul>
                </form-row>
                <form-row ng-if="vm.TokenService.isBudgetModuleEnabled() && vm.form.model.budgetType" error="vm.form.errors.budgetSum">
                    <label class="label">
                        {{ 'course.Price' | translate }}
                    </label>
                    <div class="items">
                        <input ng-disabled="!vm.PrivilegeService.canManageOccurrences()"
                               ng-readonly="!vm.PrivilegeService.canManageOccurrences()"
                               ng-model="vm.form.model.budgetSum" type="number" min="1" class="form-control small">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </form-wrapper>
            <button type="submit" class="hidden" >{{ 'general.Next' | translate }}</button>
        </form>
        <ul class="actions01">
            <li class="primary" ng-if="vm.PrivilegeService.canManageOccurrences()">
                <a ng-if="vm.form.model.id && !vm.course.isArchived" ng-click="vm.confirmAndSave()" class="btn main">
                    <span>{{ 'general.Save ' | translate }}</span>
                </a>
                <a ng-if="!vm.form.model.id && !vm.course.isArchived" ng-click="vm.save()" class="btn main">
                    <span>{{ 'general.Next' | translate }}</span>
                </a>
            </li>
            <li class="primary" ng-if="vm.showCancelBtn && !vm.course.isArchived">
                <a ng-click="vm.cancel()" class="btn">
                    <span>{{ 'general.Cancel occurrence' | translate }}</span>
                </a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.list()" class="btn discrete" >
                    <span ng-if="vm.form.model.id">{{ 'general.Back to list' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($translate, $state, $scope, lodash,
                 OccurrenceService, PrivilegeService, TokenService,
                 ModalService, FilterService, SiteService, MomentService,
                 OccurrenceResource, OCCURRENCE_STATUS_ENUM, OCCURRENCE_LANGUAGE_ENUM,
                 OCCURRENCE_BUDGET_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, COURSE_SITE_ACCESS_ENUM,
                 COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM, moment
    ) {
        this.$translate = $translate;
        this.$state = $state;
        this.$scope = $scope;
        this.lodash = lodash;
        this.OccurrenceService = OccurrenceService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.SiteService = SiteService;
        this.MomentService = MomentService;
        this.FilterService = FilterService;
        this.OccurrenceResource = OccurrenceResource;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.OCCURRENCE_LANGUAGE_ENUM = OCCURRENCE_LANGUAGE_ENUM;
        this.OCCURRENCE_BUDGET_ENUM = OCCURRENCE_BUDGET_ENUM;
        this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
        this.COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = COURSE_OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.moment = moment;
    }

    $onInit () {
        if (this.form.model.displayUntil && !this.isDateValid(this.form.model.displayUntil)) {
            this.form.model.displayUntil = this.MomentService.formatTimeStamp(this.form.model.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }
        const accessToAllSites = this.SiteService.hasAccessToAllSites(this.sites);
        this.disableAllSitesOption = false;
        this.showAllSitesOption = this.form.model.siteId === null || accessToAllSites;
        this.showCancelBtn = this.occurrence.id
            && this.PrivilegeService.canManageOccurrences()
            && !this.OccurrenceService.isCancelled(this.occurrence);

        this.oldSiteId = this.form.model.siteId ? this.form.model.siteId.toString() : null;
        this.oldVersionId = this.form.model.courseVersionId ? this.form.model.courseVersionId : null;
        this.oldAccessPeriod = this.form.model.accessPeriod ? this.form.model.accessPeriod : null;
        this.oldAccessPeriodType = this.form.model.accessPeriodType ? this.form.model.accessPeriodType : null;

        // set default site id if add scenario and there is only one site option
        if (!this.form.model.siteId && !this.occurrence.id && this.sites.length === 1) {
            this.form.model.siteId = this.sites[0].id;
        }

        if (!this.form.model.siteId && !this.occurrence.id && this.course.company.isTrainingCompany && this.SiteService.hasAccessToAllSites(this.sites)) {
            this.form.model.isExternalSiteUserExcluded = true;
        }

        // if site id is set, convert it to toString because ng-select handles string values
        if (this.form.model.siteId) {
            this.form.model.siteId = this.form.model.siteId.toString();
        }

        if (!this.form.model.siteAccess) {
            if (this.SiteService.hasAccessToAllSites(this.sites)) {
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }
        }

        // In case of occurrence add scenario:
        //  * choose initial version as default value
        //  * only not archived versions are selectable
        if (!this.form.model.id) {
            this.form.model.courseVersionId = this.courseVersions[0].id;
            this.filterCourseVersions();
        }
        else {
            this.filterCourseVersions(false);
        }

        this.initGeneralDataTabFields();

        if (!this.occurrence.id) {
            this.occurrence.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            if (this.showAllSites()) {
                this.occurrence.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
        }

        this.initMultiFilter();

        this.languages = [];
        if (this.form.model.courseOccurrenceLanguages && this.form.model.courseOccurrenceLanguages.length) {
            this.languages = this.form.model.courseOccurrenceLanguages.map(item => ({ value: item.language, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS[item.language] }));
        }
        else {
            const companyLang = this.course.company.defaultLanguage;
            this.languages = [{ value: companyLang, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS[companyLang] }];
        }

        this.langOptions = [
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.ET, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.ET },
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.EN, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.EN },
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.LV, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.LV },
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.LT, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.LT },
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.RU, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.RU },
            { value: this.OCCURRENCE_LANGUAGE_ENUM.KEYS.NO, label: this.OCCURRENCE_LANGUAGE_ENUM.LABELS.NO }
        ];

        this.filterTranslations = this.FilterService.getTranslations();
        this.directManagerSelect = this.getManagerSelect();
        this.tooltipTexts = {
            name: this.$translate.instant('course.Occurrence name tooltip'),
            externalUsage: this.$translate.instant('course.Occurrence externalUsage tooltip'),
            automaticRegistration: this.$translate.instant('course.Occurrence automaticRegistration tooltip')
        };
    }

    isDateValid (date) {
        const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        return String(date).match(regex);
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
        || this.occurrence.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }


    initMultiFilter () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };

        const siteOptions = this.getSiteOptions();
        // NOTE: selectedOptions objects must be same as site options objects for multiselect to work
        const selectedSiteOptions = this.getSelectedSiteOptions(siteOptions);

        this.multiFilter = {
            sites: {
                models: selectedSiteOptions,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 5,
                    smartButtonTextConverter: (itemText) => itemText
                },
                events: {
                    onItemDeselect: this.getSiteItemCallback(selectedSiteOptions),
                    onItemSelect: this.getSiteItemCallback(selectedSiteOptions)
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            }
        };
    }

    /**
     * This callback makes sure that all sites option is always selected alone
     * - if all sites is selected uncheck every other option
     * - if any actual site option is selected unchecks all sites option
     * @returns {Function}
     */
    getSiteItemCallback () {
        return item => {
            const { multiFilter } = this;
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === null) {
                multiFilter.sites.models = [this.allSitesOption];
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                multiFilter.sites.models = multiFilter.sites.models.filter(model => model.value !== null);
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }
        };
    }

    getSelectedSiteOptions (siteOptions) {
        let selectedOptions = [];
        // selected
        if (this.occurrence.sites && this.occurrence.sites.length) {
            const selectedSiteIds = this.occurrence.sites.map(site => site.id);
            selectedOptions = siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
        }
        else if (this.occurrence.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            selectedOptions.push(this.allSitesOption);
        }
        else {
            selectedOptions.push(...siteOptions);
        }
        return selectedOptions;
    }

    getSiteOptions () {
        const siteOptions = [];
        const cb = site => {
            return {
                value: site.id,
                label: site.name
            };
        };

        // 1. map all sites option if its selected or if user can manage site access
        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }
        // 2. map sites that user has access to via privileges
        this.lodash.forEach(this.sites, site => {
            siteOptions.push(cb(site));
        });

        // 3. map already attached course sites
        if (this.occurrence.sites && this.occurrence.sites.length) {
            this.lodash.forEach(this.occurrence.sites, site => {
                siteOptions.push(cb(site));
            });
        }

        // 4. remove duplicates that might've come from sites and course.sites
        return this.lodash.uniqBy(siteOptions, option => option.value);
    }

    confirmAndSave () {
        // always reload occurrence to get correct participant count for confirm message
        this.OccurrenceResource.get({
            id: this.occurrence.id,
            expand: 'courseOccurrenceParticipants,sites'
        }).$promise.then(occurrence => {
            const userCount = occurrence.courseOccurrenceParticipants.length;
            const siteHasChanged = this.oldSiteId !== this.form.model.siteId && userCount;
            const versionHasChanged = this.oldVersionId && this.oldVersionId !== this.form.model.courseVersionId;

            if (siteHasChanged || versionHasChanged) {
                let message = '';
                if (siteHasChanged && versionHasChanged) {
                    message = this.$translate.instant('occurrence.alias.site_and_version_confirmation_message', { count: userCount });
                }
                else if (siteHasChanged) {
                    message = this.$translate.instant('occurrence.alias.site_confirmation_message', { count: userCount });
                }
                else {
                    message = this.$translate.instant('occurrence.alias.version_confirmation_message');
                }

                this.ModalService.confirm(message, 'medium').then(() => {
                    this.save();
                });
            }
            else {
                if (this.isPublishedOccurrence() && this.form.model.isMarketplaceOccurrence) {
                    if (this.oldAccessPeriod !== this.form.model.accessPeriod ||
                    this.oldAccessPeriodType !== this.form.model.accessPeriodType) {
                        this.ModalService.confirm(
                            this.$translate.instant('occurrence.alias.access_period_confirmation_message'),
                            'medium').then(() => {
                                this.save();
                            }
                        );
                    }
                    else {
                        this.save();
                    }
                }
                else {
                    this.save();
                }
            }
        });
    }

    save () {
        let siteIds = !this.multiFilter.sites.models.length ? [-1] : this.multiFilter.sites.models.map(site => site.value);
        siteIds = siteIds.filter(site => site !== null);
        this.form.model.siteIds = siteIds;
        this.form.model.languages = [];
        this.form.model.languages = this.languages.map(language => language.value);

        // if "All sites" is not selected, mark exclude external sites as false
        if (siteIds.length) {
            this.form.model.isExternalSiteUserExcluded = false;
        }

        this.form.model.siteAccess = siteIds.length ? this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES : this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;

        if (this.form.model.publishDate && !this.isDateValid(this.form.model.publishDate)) {
            this.form.model.publishDate = this.MomentService.formatTimeStamp(this.form.model.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
        }

        delete this.form.model.courseOccurrenceParticipants;

        this.form.model.directManagerIds = [];
        if (this.form.model.isExposedToDirectManagers) {
            this.form.model.directManagerIds = this.directManagerSelect.model.map(manager => manager.value);
        }

        this.form.save().then((model) => {
            this.occurrence = model;
            if (this.context === 'add') {
                this.$state.go('authorized.courses.courses.edit.occurrence.add.employee', {
                    id: this.$state.params.id, occurrenceId: this.occurrence.id
                });
            }
            this.form.model.siteId = model.siteId ? model.siteId.toString() : null;
            if (model.displayUntil) {
                this.form.model.displayUntil = this.MomentService.formatTimeStamp(model.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
            }
            if (this.form.model.hideFromMarketplaceList) {
                this.form.model.hideFromMarketplaceList = true;
            }
        });
        this.filterCourseVersions(false);
    }

    /**
     * Checks whether date is in the correct format of YYY-MM-DD HH:mm:ss
     *
     * @param {string} date
     */
    isDateValid (date) {
        const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        return String(date).match(regex);
    }

    filterCourseVersions (isNewVersion = true) {
        if (isNewVersion) {
            this.courseVersions = this.courseVersions.filter(version => version.isArchived === false);
        }
        else {
            // if editable occurrence is already linked to archived version, leave it this way
            this.courseVersions = this.courseVersions.filter(
                version => this.form.model.courseVersionId === version.id || version.isArchived === false
            );
        }
    }

    getInAssessmentParticipants (occurrence) {
        return occurrence.courseOccurrenceParticipants
            ? occurrence.courseOccurrenceParticipants.filter(
                (participant) => participant.courseProgressStatus === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT
            )
            : [];
    }

    cancel () {
        const inAssessmentCount = this.getInAssessmentParticipants(this.occurrence).length;
        const totalCount = this.occurrence.courseOccurrenceParticipants
            ? this.occurrence.courseOccurrenceParticipants.length : 0;
        const finishedCount = this.OccurrenceService.getFinishedParticipants(this.occurrence).length;

        const translationKey = inAssessmentCount > 0
            ? 'occurrence.cancel_confirmation_message_with_assessment'
            : 'occurrence.cancel_confirmation_message';

        const confirmMessage = this.$translate.instant(translationKey, {
            totalCount,
            finishedCount,
            inAssessmentCount
        });

        if (this.form.model.isExposedToDirectManagers) {
            this.occurrence.directManagerIds = this.directManagerSelect.model.map(manager => manager.value);
        }

        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            if (this.occurrence.publishDate && !this.isDateValid(this.occurrence.publishDate)) {
                this.occurrence.publishDate = this.MomentService.formatTimeStamp(this.occurrence.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
            }

            delete this.occurrence.courseOccurrenceParticipants;

            this.occurrence.languages = this.languages.map(language => language.value);
            this.occurrence.status = this.OCCURRENCE_STATUS_ENUM.KEYS.CANCELLED;
            this.OccurrenceResource.update({ id: this.occurrence.id, expand: 'courseOccurrenceParticipants,sites' }, this.occurrence).$promise.then((occurrence) => {
                this.$scope.$emit('occurrence:reload', occurrence);
                this.OccurrenceService.copyFrom(
                    this.occurrence,
                    this.$translate.instant('occurrence.Occurrence cancelled successfully')
                );
            });
        });
    }

    initGeneralDataTabFields () {
        if (!this.form.model.isMarketplaceOccurrence) {
            this.form.model.isMarketplaceOccurrence = false;
        }

        if (!this.form.model.isMarketplaceRegistrationDisabled) {
            this.form.model.isMarketplaceRegistrationDisabled = false;
        }

        if (!this.form.model.hideFromMarketplaceList) {
            this.form.model.hideFromMarketplaceList = false;
        }
        else {
            this.form.model.hideFromMarketplaceList = true;
        }

        if (!this.form.model.marketplaceSalesPrice) {
            this.form.model.marketplaceSalesPrice = 0;
        }

        if (!this.form.model.isOptionalTargetsOccurrence) {
            this.form.model.isOptionalTargetsOccurrence = false;
        }
    }

    filterLanguages (value) {
        return this.langOptions.filter((language) => this.lodash.includes(language.label.toUpperCase(), value.toUpperCase()));
    }

    getManagerSelect () {
        let managers;
        if (!this.form.model.siteId) {
            managers = this.directManagers;
        }
        else {
            const siteId = parseInt(this.form.model.siteId, 10);
            managers = this.lodash.filter(
                this.directManagers,
                manager => this.lodash.find(manager.userAssignments, ua => ua.siteId === siteId)
            );
        }

        const managerOptions = managers.map(manager => {
            return {
                value: manager.id,
                label: manager.displayName
            };
        });

        const directManagerIds = [];
        this.lodash.forEach(this.form.model.courseOccurrenceManagers, manager => {
            directManagerIds.push(manager.userId);
        });

        const managersSelected = this.lodash.filter(managerOptions, manager => {
            return this.lodash.includes(directManagerIds, manager.value);
        });

        return {
            model: managersSelected,
            options: managerOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                enableSearch: true,
                smartButtonMaxItems: 5
            }
        };
    }

    isPublishedOccurrence () {
        return this.form.model.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED;
    }

    updateDirectManagerSelect () {
        this.directManagerSelect = this.getManagerSelect();

        if (this.course.company.isTrainingCompany) {
            this.setExternalSiteUserExcludedValueState();
        }
    }

    setExternalSiteUserExcludedValueState () {
        if (!this.form.model.siteId) {
            this.form.model.isExternalSiteUserExcluded = true;
        }
        else {
            this.form.model.isExternalSiteUserExcluded = false;
        }
    }

    getSelectedDirectManagersAsString () {
        return this.lodash.map(this.directManagerSelect.model, model => model.label).join(', ');
    }

    afterMarketplaceSalesPriceChange () {
        if (!this.form.model.marketplaceSalesPrice) {
            this.form.model.marketplaceSalesPrice = 0;
        }
    }

    getAccessLimitTooltipText () {
        return this.$translate.instant(
            'courses.Is meant for cases when the deadline for the whole course is really long ' +
            'and the access to the course needs to be limited to a shorter period. Access time starts ' +
            'when employee opens the course for the first time'
        );
    }

    handleLimitAccessEnabled () {
        this.form.model.accessPeriod = null;
        this.form.model.accessPeriodType = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/general/index.js